import styles from './SuccessMessage.module.css';
import { useModal } from '../../hooks/modalContext';
import { useLogo } from '../../hooks/LogoContext';
import clsx from 'clsx';
import { useTheme } from '../../hooks/ThemeContext';

const SuccessMessage = () => {
  const { setModal, modalState } = useModal();
  const { theme } = useTheme();
  const { logoUrl, logoLoading } = useLogo();
  const isDark = theme === 'dark';
  const { message } = modalState || { message: '' };
  return (
    <main className={clsx(styles.main, isDark && styles.mainDark)}>
      <section className={styles.section}>
        <div className={styles.message}>
          {!logoLoading && <img src={logoUrl} className={styles.logo} alt='logo' />}
          <h2 className={`${styles.heading} ${isDark && styles.headingDark}`}>{message}</h2>
          <div className={styles.messageContent}>Autopay has been disabled for this building.</div>
          <button
            className={styles.closeBtn}
            onClick={() => {
              setModal(null);
            }}
          >
            Close
          </button>
        </div>
      </section>
    </main>
  );
};
export default SuccessMessage;
